module.exports = __webpack_public_path__ + "img/victor.1b9dc25c.jpg";